export const data = [
  {
    id: 1,
    provider: "Run12",
    location: "Port Blair, Andaman And Nicobar Islands",
    user: "--",
    userDesc: "--",
    status: "Active",
    created: "Apr 29, 2024 05:06 PM",
    modified: "Apr 29, 2024 06:24 PM",
  },
  {
    id: 2,
    provider: "VRG",
    location: "Hyderabad, Telangana",
    user: "--",
    userDesc: "--",
    status: "Active",
    created: "Mar 22, 2024 05:38 PM",
    modified: "Mar 22, 2024 05:51 PM",
  },
  {
    id: 3,
    provider: "CARE Hospitals",
    location: "Port Blair, Andaman And Nicobar Islands",
    user: "Mohan",
    userDesc: "mohan+care.provider+6@unify.digital",
    status: "Active",
    created: "Mar 22, 2024 05:38 PM",
    modified: "Mar 22, 2024 05:51 PM",
  },
  {
    id: 4,
    provider: "--",
    location: "--",
    user: "Dora Sai Teja",
    userDesc: "mohan+care.provider+6@unify.digital",
    status: "Active",
    created: "Mar 14, 2024 12:34 PM",
    modified: "Mar 18, 2024 05:00 PM",
  },
];

export const LocationFrom = {
  UserBasicInfo: [
    {
      type: "text",
      label: "Display Name",
      id: "displayName",
      placeholder: "Enter Display Name",
      required: true,
    },
    {
      type: "text",
      label: "Name",
      required: true,
      id: "name",
      placeholder: "Enter Name",
    },

    {
      type: "number",
      label: "Phone Number",
      required: true,
      id: "phoneNumber",
      placeholder: "Enter your Number",
    },
    {
      type: "text",
      label: "Address 1",
      required: true,
      id: "address1",
      placeholder: "Address 1",
    },
    {
      type: "text",
      label: "Address 2",
      id: "address2",
      placeholder: "Address 2",
    },
    {
      type: "text",
      label: "Country",
      required: true,
      id: "country",
      placeholder: "Enter Country",
    },
    {
      type: "text",
      label: "State",
      required: true,
      id: "state",
      placeholder: "Enter State",
    },
    {
      type: "text",
      label: "City",
      required: true,
      id: "city",
      placeholder: "Enter City",
    },
   
    {
      type: "number",
      label: "Zipcode",
      required: true,
      id: "zipCode",
      placeholder: "Enter ZipCode",
    },
    {
      type: "text",
      label: "HFR Id",
      id: "HfrId1",
      placeholder: "IN203023222",
    },
    {
      type: "text",
      label: "Re-enter HFR Id",
      id: "HfrId2",
      placeholder: "IN203023222",
    },
  ],
};
